module.exports = __webpack_public_path__ + "static/scale-model-of-kern-county-museum-in-bakersfield-california-5623c507ebb637d0f6fedbea57a45cb8.png";